import { ReactElement } from "react";
import { Pager } from "../Pager/Pager";
import { PageInfo } from "../PageInfo/PageInfo";
import styles from "./Pagination.module.less";
import { setTrackingId } from "client/Misc/utils";

export type PaginationProps = {
	pageNumber: number;
	pagesCount: number;
	firstItemIndex: number;
	lastItemIndex: number;
	itemsCount: number;
	onPageNumberChanged(newPageNumber: number): void;
	trackingId?: string;
};

export const Pagination = (props: PaginationProps): ReactElement => {
	const {
		firstItemIndex,
		itemsCount,
		lastItemIndex,
		pageNumber,
		pagesCount,
		onPageNumberChanged,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<div className={styles.pagerContainer}>
				<Pager
					pageNumber={pageNumber}
					pagesCount={pagesCount}
					onNewPageNumber={onPageNumberChanged}
					trackingId="pager"
				/>
			</div>
			<div className={styles.pageInfoContainer}>
				<PageInfo
					firstItemIndex={firstItemIndex}
					lastItemIndex={lastItemIndex}
					totalAmountOfItems={itemsCount}
					trackingId="info"
				/>
			</div>
		</div>
	);
};

Pagination.displayName = "Pagination";